<template lang="html">
  <div class="sign-up-coupon" v-if="isCouponShow">
    <div class="sign-up-coupon-content">
      <div class="sign-up-coupon-main">
        <p>恭喜你</p>
        <p>获得通用代金券</p>
        <p>有效期：{{couponTime}}</p>
        <div class="sign-up-coupon-main-price">￥<span>{{couponPrice}}</span>元</div>
        <div v-if="!isSend && routeValue !== 'mine-coupon'" class="sign-up-coupon-main-button" @click="buy">立即=订阅</div>
        <div v-else class="sign-up-coupon-main-button" @click="send">赠送好友</div>
        <div v-if="routeValue === 'mine-coupon'" class="sign-up-coupon-main-button" @click="close">确 认</div>
      </div>
      <div class="sign-up-coupon-close" @click="close">
        <img src="../../assets/images/sign-up-coupon-close.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUpCoupon',
  data () {
    return {
      isCouponShow: false,
      couponPrice: 0,
      couponTime: '',
      isSend: 0
    }
  },
  computed : {
    routeValue () {
      return this.$route.name
    }
  },
  created (){
    this.setCouponPrice()
  },
  methods: {
    setCouponPrice () {
      let isCouponShow = window.sessionStorage.getItem('isCouponShow')
      if (isCouponShow) {
        this.isCouponShow = false
      } else {
        let {couponPrice, couponTime, isSend} = this.$route.query
        if (isSend) {
          this.isSend = isSend
        }
        if (couponPrice && couponTime) {
          this.isCouponShow = true
          this.couponPrice = couponPrice
          this.couponTime = couponTime
        }
      }
    },
    buy () {
      this.close()
      this.$emit('buy')
    },
    send () {
      this.close()
      this.$emit('send')
    },
    close () {
      this.isCouponShow = false
      window.sessionStorage.setItem('isCouponShow', true)
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.sign-up-coupon {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0,0,0,.4);
  z-index: 9999999;
  color: #fff;
  text-align: center;
  &-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  &-close {
    margin-top: rem(32);
    > img {
      width: rem(80);
    }
  }
  &-main {
    width: rem(500);
    height: rem(550);
    padding: rem(40) 0;
    background: url('../../assets/images/sign-up-coupon-bg.png');
    background-size: 100% 100%;
    position: relative;
    > p {
      line-height: 1.5;
      &:first-child {
        font-size: rem(42);
        margin-bottom: rem(18);
        font-weight: bold;
      }
      &:nth-child(2) {
        font-size: rem(36);
        margin-bottom: rem(5);
        font-weight: bold;
      }
      &:nth-child(3) {
        font-size: rem(24);
        margin-bottom: rem(26);
      }
    }
    &-price {
      width: rem(366);
      height: rem(156);
      line-height: rem(156);
      background: url('../../assets/images/sign-up-coupon-price.png');
      background-size: 100% 100%;
      font-size: rem(42);
      margin: auto;
      > span {
        font-size: rem(100);
      }
    }
    &-button {
      width: rem(360);
      height: rem(75);
      line-height: rem(75);
      position: absolute;
      left: 50%;
      bottom: 8%;
      transform: translateX(-50%);
      color: #E33337;
      background-color: #fff;
      border-radius: rem(35);
    }
  }
}
</style>
